import Header from 'components/Header/Header';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getFP, getIP } from 'service/base';
import { twMerge } from 'tailwind-merge';

const HistoryPage = () => {
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await getIP();
        setIP(res);
      } catch (e) {}
    };
    const fetchFP = async () => {
      try {
        const res = await getFP();
        setFP(res);
      } catch (e) {}
    };
    fetchIP();
    fetchFP();
  }, []);

  return (
    <div className={twMerge(SITE, 'w-full min-h-screen')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/bao.png"
        alt=""
        className="pointer-events-none fixed bottom-[60px] left-[32px] z-[1] hidden lg:block"
      />
      <img
        src="/assets/images/chim.png"
        alt=""
        className="pointer-events-none fixed bottom-[55px] right-[20px] z-[1] hidden lg:block"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />
        <div
          className="mx-auto max-w-[1200px] mt-2 bg-white border-[2px] border-solid border-[#FB8C00] shadow shadow-primary p-4 w-full md:pb-8 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF',
            borderColor: '#FB8C00'
          }}
        >
          <HistoryPredictions variant="page" IP={IP} FP={FP} />
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
